import { Link } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";
import { SchemaJsonLd, breadcrumbSchema } from "@/lib/seo";

/**
 * Accessible breadcrumb trail with BreadcrumbList JSON-LD injection.
 *
 * Usage:
 *   <Breadcrumbs items={[
 *     { name: "Water Tests", url: "/" },                  // ancestors (Link to)
 *     { name: "AWARE Tank 360" }               // current (no url => not a link)
 *   ]} />
 *
 * The "Home" root is added automatically and points to `/`.
 */
const BASE = "https://awarewatertesting.com.au";

export function Breadcrumbs({ items = [] }) {
  const trail = [{ name: "Home", url: "/" }, ...items];
  const schemaItems = trail.map((it) => ({
    name: it.name,
    url: it.url ? `${BASE}${it.url}` : `${BASE}${window.location.pathname}`,
  }));
  return (
    <>
      <SchemaJsonLd
        data={breadcrumbSchema(schemaItems)}
        id="jsonld-breadcrumb"
      />
      <nav
        aria-label="Breadcrumb"
        data-testid="breadcrumbs"
        className="text-xs sm:text-sm text-slate-500"
      >
        <ol className="flex items-center flex-wrap gap-1.5">
          {trail.map((it, i) => {
            const isLast = i === trail.length - 1;
            return (
              <li key={i} className="flex items-center gap-1.5">
                {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-400" aria-hidden />}
                {isLast || !it.url ? (
                  <span
                    aria-current="page"
                    className="text-slate-900 font-medium inline-flex items-center gap-1"
                  >
                    {i === 0 && <HomeIcon className="w-3.5 h-3.5" aria-hidden />}
                    {it.name}
                  </span>
                ) : (
                  <Link
                    to={it.url}
                    className="hover:text-cyan-700 transition-colors inline-flex items-center gap-1"
                  >
                    {i === 0 && <HomeIcon className="w-3.5 h-3.5" aria-hidden />}
                    {it.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}

export default Breadcrumbs;
